import Images from "../../Assets/Images/Index";
import React, { useState } from "react";
import "./Footer.css";
import { useNavigate } from "react-router-dom";
import {
  Facebook,
  Instagram,
  MailCheck,
  MapPinCheckInside,
  Phone,
  Twitter,
  Youtube,
  YoutubeIcon,
} from "lucide-react";
function Footer() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <img
            src={Images.Footerlogo}
            alt="Footer Logo"
            className="footer-logo"
            style={{ display: "block", margin: "0 auto" }}
          />

          <p style={{ display: "flex", justifyContent: "center" }}>
            Follow us on
          </p>
          <div className="d-flex justify-content-evenly ">
            <a href="https://www.facebook.com/profile.php?id=61574469325452">
              <Facebook />
            </a>
            <a href="https://x.com/qflyers">
              {" "}
              <Twitter />
            </a>
            <a href="https://www.instagram.com/qflyers/">
              {" "}
              <Instagram />
            </a>
            <a href="https://www.youtube.com/@Qflyers">
              <YoutubeIcon />
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h1>Product</h1>
          <p>Home</p>
          <p>Template</p>
          <p>Pricing</p>
          <p>Contact Us </p>
          <p>Goals </p>
        </div>
        <div className="footer-section">
          <h1>Use Cases</h1>
          <p>Cafe</p>
          <p>Ice Cream Shop</p>
          <p>Restaurants</p>
          <p>Flower Shop</p>
          <p>Doctor</p>
          <p>Sip Society</p>
          <p>Tools Shop</p>
          <p>Diwali</p>
          <p>Furniture</p>
        </div>
        <div className="footer-section">
          <h1>Company</h1>
          <p onClick={() => handleNavigate("/Faq")}>FAQs</p>
          <p onClick={() => handleNavigate("/Terms")}>Terms & Conditions</p>
          <p onClick={() => handleNavigate("/PrivacyPolicy")}>Privacy Policy</p>
          <p onClick={() => handleNavigate("/CancelationandRefund")}>
            Cancelation and Refund policy{" "}
          </p>
        </div>
        <div className="footer-section">
          <h1>Contact Us</h1>

          <p>
            <MapPinCheckInside className="icon" /> No 48,Kovai Thirunagar,
            Goldwins,Coimbatore-641004
          </p>
          <p>
            <MailCheck className="icon" />
            {"  "}
            support@qflyers.com
          </p>
          <p>
            <Phone className="icon" />
            {"  "}
            +91 800 854-36-80
          </p>
        </div>
      </div>
      <hr />
      <p className="footer-copy">
        &copy; {new Date().getFullYear()} Qflyers. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
